/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperState = {
    filtersExpandedStorageKey: 'liveSearchFiltersExpandedState',
    lastVisitedCategoryPathStorageKey: 'liveSearchLastVisitedCategoryPath',
    /**
     * Read session storage value and decode JSON payloads used by Alpine persist.
     *
     * @param {string} key
     * @returns {string}
     */
    getSessionStorageValue(key) {
        const rawValue = window.sessionStorage.getItem(key)
        if (rawValue === null) {
            return ''
        }

        try {
            const parsedValue = JSON.parse(rawValue)
            return typeof parsedValue === 'string' ? parsedValue : String(parsedValue)
        } catch (error) {
            return rawValue
        }
    },
    /**
     * Resolve initial helper-expanded state before first render.
     *
     * @returns {boolean}
     */
    getInitialFiltersExpandedState() {
        if (typeof window === 'undefined' || !window.sessionStorage || !window.liveSearchConfig) {
            return false
        }

        const isPersistedExpanded = this.getSessionStorageValue(this.filtersExpandedStorageKey) === '1'
        if (!isPersistedExpanded) {
            return false
        }

        const currentCategoryPath = window.liveSearchConfig.currentCategoryPath || ''
        const lastVisitedCategoryPath = this.getSessionStorageValue(this.lastVisitedCategoryPathStorageKey)

        return currentCategoryPath !== '' && currentCategoryPath === lastVisitedCategoryPath
    }
}

export default liveSearchHelperState
